// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_hxv","badges":"styles_badges__2EMnA"};